'use strict';
var globalConfig = require('../config/global');
var headerBanner = require('./header-banner');
var root = document.documentElement;
var isWebflowPage = document.querySelectorAll('.webflow-page, .webflow-homepage').length > 0;
var webflowOffset = require('./webflowOffset');
var temporaryBannerExists = document.querySelectorAll('#temporary-banner').length > 0;

/**
 * Offset site content per fluid header height on resize
 */
function mainContentResize() {
    var headerHeight = $('header').height() + 'px';
    root.style.setProperty('--maincontent-top', headerHeight);
    root.style.setProperty('--modal-background-top', headerHeight);
    root.style.setProperty('--refinements-sticky-top', headerHeight);
    root.style.setProperty('--refinements-sticky-top', headerHeight);

    if (isWebflowPage) {
        webflowOffset.initOffsetWebflowContent();

        if (temporaryBannerExists) {
            headerBanner.initResizeBannerWebflow();
        }
    }

    if (!isWebflowPage) {
        if (temporaryBannerExists) {
            $('#maincontent, .modal-background, .container.search-results .refinements-sticky, .contact-form-anchor-container, .contact-modal-anchor-container').addClass('resizing');
            var processedHeaderHeight = $('.header.container').height() + $('.header-banner').height();
            root.style.setProperty(
                '--banner-maincontent-top', processedHeaderHeight + 'px'
            );
            root.style.setProperty(
                '--banner-modal-top', processedHeaderHeight + 'px'
            );
            root.style.setProperty(
                '--banner-refinements-top', processedHeaderHeight + 'px'
            );
        }
    }

    if (document.querySelectorAll('.page-clearheader, .wf-clearheader').length > 0) {
        var processedBannerHeight = $('.header-banner').height() + 'px';
        root.style.setProperty(
            '--banner-clearheader-top', processedBannerHeight
        );
    }
}
/**
 * Offset site content per fluid header height
 */
function mainContentOffset() {
    var headerHeight = $('header').height() + 'px';
    root.style.setProperty('--maincontent-top', headerHeight);
    root.style.setProperty('--modal-background-top', headerHeight);
    root.style.setProperty('--refinements-sticky-top', headerHeight);

    if (document.querySelectorAll('.page-clearheader').length > 0) { $('.modal-background').addClass('page-clearheader'); }
    if (document.querySelectorAll('.wf-clearheader').length > 0) { $('.modal-background').addClass('wf-clearheader'); }

    if (isWebflowPage) {
        webflowOffset.webflowBackToTopBtn();

        if ((document.querySelectorAll('.webflow_subnav_top_border').length > 0)) {
            $('header').addClass('webflow-bottom-border');
        }
        webflowOffset.initOffsetWebflowContent();
        if (temporaryBannerExists) {
            setTimeout(function () {
                headerBanner.initTempBannerWebflow();
            }, 200);
        }
    }

    if (temporaryBannerExists && !isWebflowPage) {
        headerBanner.initTemporaryBanner();
    }
}

/**
 * Generates the modal window on the first call.
 * @param {string} modalBodyContent - HTML that should be inserted into the modal
 */
function getModalHtmlElement(modalBodyContent) {
    if ($('#videoModal').length !== 0) {
        $('#videoModal').remove();
    }

    var $content = $(globalConfig.components.global.modal.template);
    $content.find('.modal-body').append(modalBodyContent);

    $('body').append($content);
}

module.exports = {

    /**
     * inits all of the global carousel compoents
     * @see globalConfig - configs/global.js
     */
    initGlobalCarousels: function () {
        var Carousel = require('./carousel');

        globalConfig.components.global.carouselArr.forEach(function (carouselName) {
            var $imageCarousel = new Carousel(carouselName);

            // activate image Carousel
            $imageCarousel.activate();
        });
    },

    /**
     * inits all of the global tooltips
     * @see globalConfig - configs/global.js
     */
    initGlobalTooltips: function () {
        $(globalConfig.components.global.tooltipElement).tooltip();
    },

    initGlobalModalContentLinks: function () {
        globalConfig.components.global.modal.elements.forEach(function (modalEle) {
            var $modalEle = $(modalEle);

            if ($modalEle.length > 0 && $modalEle.hasClass('popup-video') && $modalEle.data('src')) {
                // when the modal is opened autoplay it
                $modalEle.on('click', function () {
                    var videoContent = '<div class="embed-responsive embed-responsive-16by9">'
                        + '<iframe class="embed-responsive-item video-embed" src="" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
                        + '</div>';

                    getModalHtmlElement(videoContent);
                    $('#cmsModal').modal('show');

                    /**
                     * set the video src to autoplay and not to show related video.
                     * Youtube related video is like a box of chocolates... you
                     * never know what you're gonna get
                     */
                    $('.video-embed').attr('src', $(this).data('src') + '?autoplay=1');

                    // stop playing the youtube video when I close the modal
                    $('#cmsModal').on('hide.bs.modal', function () {
                        var $cmsModal = $('#cmsModal');
                        // a poor man's stop video
                        $cmsModal.find('.video-embed').attr('src', '');
                        $cmsModal.remove();
                    });
                });
            }

            if ($modalEle.length > 0 && $modalEle.hasClass('popup-content') && $modalEle.data('src')) {
                // when the modal is opened autoplay it
                $modalEle.on('click', function () {
                    $.ajax({
                        url: $modalEle.data('src'),
                        method: 'GET',
                        dataType: 'json',
                        success: function (data) {
                            getModalHtmlElement(data.content.body);
                            $('#cmsModal').modal('show');

                            // stop playing the youtube video when I close the modal
                            $('#cmsModal').on('hide.bs.modal', function () {
                                $(this).remove();
                            });
                        }
                    });
                });
            }
        });
    },

    /**
     * inits the header scroll watching for cms pages with clear header
     *
     */
    initHeaderScroll: function () {
        var $clearHeader = $('.header-container-clear, .immersive');
        var $searchInput = 'input.search-field';
        if ($clearHeader.length > 0) {
            $(document).ready(function () {
                if (window.scrollY > 0) {
                    $clearHeader.addClass('scrolled');
                }
            });

            var clearHeaderAmt = $('#clear-header-scroll-amount').length ? $('#clear-header-scroll-amount').val() : 0;
            var $wfClearHeaderClass = '.sfcc-clearheader-me';
            var $hasClearheaderSection = document.querySelectorAll($wfClearHeaderClass);
            if ($hasClearheaderSection.length < 1) {
                $(window).scroll(function () {
                    if ($(this).scrollTop() > clearHeaderAmt) {
                        $clearHeader.addClass('scrolled');
                    } else if ($(this).scrollTop() <= clearHeaderAmt && $($searchInput).val() === '') {
                        $clearHeader.removeClass('scrolled');
                    }
                });
            } else {
                webflowOffset.webflowClearHeaderBySection($wfClearHeaderClass, $clearHeader, $searchInput);
            }

            $('.search.hidden-md-down form[name=simpleSearch]').on('focus focusin keyup keydown', $searchInput, function () {
                $clearHeader.addClass('scrolled');
            });

            $('.search.hidden-md-down form[name=simpleSearch]').on('focusout blur', $searchInput, function () {
                if ($($searchInput).val() === '') {
                    if (window.scrollY === 0) {
                        $clearHeader.removeClass('scrolled');
                    } else if ($hasClearheaderSection.length > 0) {
                        $hasClearheaderSection.forEach(function (headerStatus) {
                            if ($(headerStatus).hasClass('clear-active')) {
                                $clearHeader.removeClass('scrolled');
                            }
                        });
                    }
                }
            });
        }
    },

    newTabPDFLinks: function () {
        var links = document.getElementsByTagName('a');
        for (var i = 0; i < links.length; i++) {
            var isLinkPDF = links[i].href.slice(links[i].length - 5).toString().toLowerCase().indexOf('.pdf') > -1;
            if (isLinkPDF) {
                links[i].setAttribute('target', '_blank');
            }
        }
    },
    initMainContent: function () {
        mainContentOffset();

        $(window).on('resize', function () {
            mainContentResize();
        });
    },
    playVideo: function () {
        var $header = $('header');
        var $footer = $('footer');
        var $videoEl = $('.modalvideo-fullvideo');
        var $curalate = $('.experience-assets-curalate');

        $header.css({
            transition: 'transform 1.75s ease',
            transform: 'none'
        });

        $('.modalvideo-watch-cta').on('click', function () {
            $header.css('transition-delay', '0.3s');
            $header.css('transform', 'translateY(-100%)');
            $header.one('transitionend', function () {
                $header.addClass('d-none');
                $header.css('transition-delay', '0s');
            });
            $videoEl.css('position', 'fixed');
            $curalate.addClass('d-none');
            $footer.addClass('d-none');
        });

        $('.modalvideo-close').on('click', function () {
            $header.css('transition-delay', '0s');
            $header.removeClass('d-none');
            // Force reflow so the browser registers the d-none removal before animating
            $header[0].offsetHeight; // eslint-disable-line no-unused-expressions
            $header.css('transform', 'none');
            $videoEl.css('position', 'absolute');
            $curalate.removeClass('d-none');
            $footer.removeClass('d-none');
        });
    }
};
